<template lang="html">
  <f7-page>
    <div class="navbar">
      <div class="navbar-inner">
        <div class="left">
          <a href="#"
            @click="$f7router.back()">
            <f7-icon f7="chevron_left" />
          </a>
        </div>
        <div class="title">Nouvel itinéraire</div>
        <div class="right"></div>
      </div>
    </div>
    <TrackNew />
  </f7-page>
</template>

<script>
import TrackNew from '@/components/modules/AtlasTracks/TracksNew'
export default {
  name: 'TracksNewPage',
  components: {
    TrackNew
  }
}
</script>

<style lang="css">
</style>
